import { Component } from '@angular/core';

@Component({
    selector: 'lib-filter-list-grid-skeleton',
    templateUrl: './filter-list-grid-skeleton.component.html',
    styleUrl: './filter-list-grid-skeleton.component.css',
    standalone: false
})
export class FilterListGridSkeletonComponent {

}
